import {useState, useEffect, useMemo} from 'react';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import Table from '../table';
import ActionBar from '../actionBar';
import Portal from '../portal';
import AdminDetails from './adminDetail';
import {useAtomValue} from 'jotai';
import {pageSizeRecoil} from '../recoil';
import { dateFormatter } from '../dateFormatter';

export const AdminUsers = props => {
  const [pageNum, setPageNum] = useState(1);
  const [totalRecordsState, setTotalRecordsState] = useState(0);
  const pageSize = useAtomValue(pageSizeRecoil);
  
  const adminsVariables = useMemo(() => ({
    filters: {
      combineAnd: [
        { field: 'options.page.num', value: `${pageNum}` },
        { field: 'options.page.len', value: `${pageSize}` }
      ]
    }
  }), [pageNum, pageSize]);

  const {data, loading} = useQuery(ADMINS, {
    variables: adminsVariables
  });
  
  const admins = data?.Admins?.result || [];
  const records = data?.Admins?.metadata?.page?.records || null;
  
  const totalQueried = records ?? totalRecordsState;
  
  useEffect(()=> {
    setTotalRecordsState(totalQueried);
  }, [totalQueried]);

  const columns = [
    { dataField: 'customer_admin.id', hidden: true },
    { dataField: 'customer_admin.username', text: 'Administrator ID' },
    { dataField: 'role_names', text: 'Role' },
    {
      dataField: 'modified_at',
      text: 'Last Updated (UTC)',
      sort: true,
      formatter: dateFormatter
    }
  ];
  
  return (
    <>
      <Portal title="Administrator">
        <AdminDetails />
      </Portal>
      <ActionBar showHidden={false} showSearchBar={false} title="Administrators" />
      <Table
        testId="admin-users-table"
        columns={columns}
        data={admins}
        loading={loading}
        pageSize={pageSize}
        pageNum={pageNum}
        setPageNum={setPageNum}
        totalRecords={totalRecordsState}
      />
    </>
  );
};

const ADMINS = gql`
query getAdmins ($filters: GenericFilters) {
  Admins (filters: $filters) {
    result {
      customer_admin {
        id
        username
      }
      role_names
      modified_at
    }
    metadata {
      page {
        num
        len
        total
        inPage
        records
      }
    }
  }
}
`;

export default AdminUsers;
